'use client';
import sdk from '@/client/api/sdk';
import { components } from '@/client/api/types';
import { CODE_SUCCESS, SESSION_KEY } from '@/constants/api';
import { removeCookie } from '@/lib/cookie';
import React, { createContext, useState } from 'react';

type User = components['schemas']['UserCurrent'];

export enum LoginType {
  Email = 'email',
  Phone = 'phone',
}

interface UserContextType {
  user: User | null;
  logout: (isManualLogout?: boolean) => Promise<void>;
  logoutLoading: boolean;
  isManualLogout: boolean;
}

export const UserContext = createContext<UserContextType | undefined>(undefined);

// 创建一个内部组件来处理用户身份验证逻辑
function UserProviderInner({ children, user: initialUser }: { children: React.ReactNode; user: User | null }) {
  const [user, setUser] = useState<User | null>(initialUser);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [isManualLogout, setIsManualLogout] = useState(false);

  const logout = async (isManualLogout: boolean = true) => {
    setLogoutLoading(true);
    const resp = await sdk.POST('/api/auth/logout');
    if (resp.data?.code === CODE_SUCCESS) {
      removeCookie(SESSION_KEY);
      setIsManualLogout(isManualLogout);
      setUser(null);
    }
    setLogoutLoading(false);
  };

  return (
    <UserContext.Provider
      value={{
        user,
        logout,
        logoutLoading,
        isManualLogout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

// 导出主要的UserProvider组件，它不使用useSearchParams，将在app layout中使用
export function UserProvider({ children, user }: { children: React.ReactNode; user: User | null }) {
  // 创建一个内部Suspense边界来处理useSearchParams()
  return <UserProviderInner user={user}>{children}</UserProviderInner>;
}
